<template>
    <section class="detail-section _edit-section">
        <div class="section-inner">
            <h2 class="heading-section"><span>Detail</span></h2>

            <div class="detail-item-wrap">

                <div class="detail-item edit-checkbox">
                    <ul class="list_common">

                        <!--価値評価（Price zone）新規の時は表示しない-->
                        <Worth v-if="$store.state.detail.set.brand.price_zone && !showShowroom" />

                        <!--カテゴリ-->
                        <Category />

                        <!--プライス-->
                        <Price v-if="showBrand || showShowroom"/>

                        <!--ターゲット-->
                        <Target />

                        <!--オーダー-->
                        <Order v-if="showBrand && activeBasicBrand"/>

                    </ul>
                </div>

                <div class="detail-item">
                    <ul class="list_common">

                        <!--オンライン/WEB-->
                        <Online />

                        <!--お支払い方法-->
                        <PaymentMethod v-if="showBrand && activeBasicBrand" />

                        <!--対象店舗-->
                        <Net />

                        <!--拠点-->
                        <Base v-if="showBrand || showShowroom"/>

                        <!--所在地-->
                        <Address v-if="showShop"/>

                        <!--取り扱いブランド-->
                        <HandlingBrand v-if="showShop"/>

                    </ul>
                </div>

            </div><!--/.detail-item-wrap-->

        </div><!--/.section-inner-->

    </section>
</template>

<script>
    import Rate from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/06DetailParts/01Rate'
    import Sales from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/06DetailParts/02Sales'
    import Worth from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/06DetailParts/03Worth'
    import Category from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/06DetailParts/04Category'
    import Price from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/06DetailParts/05Price'
    import Target from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/06DetailParts/06Target'
    import SalesStyle from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/06DetailParts/07SalesStyle'
    import Order from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/06DetailParts/08Order'
    import Online from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/06DetailParts/09Online'
    import PaymentMethod from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/06DetailParts/10PaymentMethod'
    import Net from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/06DetailParts/11Net'
    import Base from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/06DetailParts/12Base'
    import Address from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/06DetailParts/13Address'
    import HandlingBrand from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/06DetailParts/14HandlingBrand'

    export default {
        components: {
            Rate,
            Sales,
            Worth,
            Category,
            Price,
            Target,
            SalesStyle,
            Order,
            Online,
            PaymentMethod,
            Net,
            Base,
            Address,
            HandlingBrand,
        },
        data() {
            return {
            };
        },
        computed: {
            showBrand() {
                var url = location.pathname;
                return url.indexOf( '/brand' ) != -1;
            },
            showShop() {
                var url = location.pathname;
                return url.indexOf( '/shop' ) != -1;
            },
            showShowroom() {
                var url = location.pathname;
                return url.indexOf( '/showroom' ) != -1;
            },
            activeBasicBrand() {
                if (this.$store.state.detail.set.activeBasicBrand) {
                    return true;
                }
            },
        },
    }
</script>

